// extracted by mini-css-extract-plugin
export default {"redDot":"selectMulti_redDot__1JLkk","label":"selectMulti_label__H5SQy","labelText":"selectMulti_labelText__SiE+v"};